<template lang="pug">
  section.JobView(v-if="data")

    PageCover(:item="data")
    .PageContent_section.PageContent-light-background
      ParagraphList(:items="data.paragraphs")
</template>

<script>
import ParagraphList from '@/components/ParagraphList'
import ParagraphWysisyg from '@/components/paragraphs/ParagraphWysisyg'
import PageCover from '@/components/PageCover'
import customTransitionMixins from '@/mixins/customTransitionMixins'
import { TweenLite, TimelineLite } from 'gsap'
import PageTransitionLayer from '@/components/PageTransitionLayer'
import JobModel from '@/models/JobModel'

export default {
  mixins: [customTransitionMixins],
  name: 'job-view',
  props: ['uuid'],
  components: {
    PageCover,
    ParagraphWysisyg,
    PageTransitionLayer,
    ParagraphList
  },
  data () {
    return {
      data: null,
      meta: null,
      paragraph: []
    }
  },
  metaInfo () {
    return this.meta
  },
  watch: {
    uuid (uuid) {
      this.loadData(uuid)
      this.fetchMeta(this.uuid)
    }
  },
  mounted () {
    this.loadData(this.uuid)
    this.fetchMeta(this.uuid)
  },
  methods: {
    loadData (uuid) {
      this.$api.getJob(this.$i18n.locale, uuid)
        .then(response => {
          this.data = new JobModel(response.data.data, response.data.included)
        })

    },
    fetchMeta () {
      this.$api.getPageMetaTag(this.$i18n.locale, this.uuid, true)
        .then(response => {
          this.meta = this.$metatag.formateMeta(response.data)
        })
    },

    transitionIn (next) {
      this.isTransitioning = true

      const timeline = new TimelineLite({ onComplete: () => {
        // On défini qu'on est plus en transition
        this.isTransitioning = false

        next()
      } })

      timeline.delay(1.2)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .JobView
    position: relative
    min-height: 100vh
    transform-origin top left

</style>
